import { isSilentError } from '@amazon/vinyl-util'
import { isAbortError } from '@/blackbolt/agent/agentUtil'
import { toastError } from '@/components/toast'
import type { ErrorReport } from '@/errorHandler'
import { asError } from '@/util/errorUtil'

export function toastDebugError({ error }: ErrorReport): void {
    if (isSilentError(error) || isAbortError(error)) return
    toastError(asError(error))
}
